import { ButtonComponentProps, Heading, Button, ButtonSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { WeldStyledProps } from './types';
import { CommodityStatusCode } from '@bechtel/types';
const buttonWidth = '112px';
function getActionStyles({ status, isInverted }: WeldStyledProps) {
  // eslint-disable-next-line no-console
  switch (status) {
    case CommodityStatusCode.CLAIMED:
    case CommodityStatusCode.FITUP_INSPECTION:
      return !isInverted
        ? css`
            background-color: ${({ theme }) => theme.colors.orange[300]};
            color: ${({ theme }) => theme.colors.orange[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.orange[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.orange[400]};
            }
          `
        : css`
            background-color: ${({ theme }) => theme.colors.green[400]};
            color: ${({ theme }) => theme.colors.green[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.green[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.green[400]};
            }
          `;
    case CommodityStatusCode.VT_APPROVED:
      return !isInverted
        ? css`
            background-color: ${({ theme }) => theme.colors.green[300]};
            color: ${({ theme }) => theme.colors.green[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.green[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.green[400]};
            }
          `
        : css`
            background-color: ${({ theme }) => theme.colors.orange[300]};
            color: ${({ theme }) => theme.colors.orange[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.orange[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.orange[400]};
            }
          `;
    case CommodityStatusCode.VT_SENT_BACK:
      return !isInverted
        ? css`
            background-color: ${({ theme }) => theme.colors.purple[300]};
            color: ${({ theme }) => theme.colors.purple[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.purple[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.purple[400]};
            }
          `
        : css`
            border: 1px solid ${({ theme }) => theme.colors.purple[300]};
          `;
    // FIXME: use enum for blocked
    case CommodityStatusCode.BLOCKED:
      return !isInverted
        ? css`
            background-color: ${({ theme }) => theme.colors.red[300]};
            color: ${({ theme }) => theme.colors.red[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.red[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.red[400]};
            }
          `
        : css`
            border: 1px solid ${({ theme }) => theme.colors.red[300]};
          `;
    case CommodityStatusCode.READY_TO_WELD:
      return !isInverted
        ? css`
            background-color: ${({ theme }) => theme.colors.blue[300]};
            color: ${({ theme }) => theme.colors.blue[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.blue[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.blue[400]};
            }
          `
        : css`
            background-color: ${({ theme }) => theme.colors.green[300]};
            color: ${({ theme }) => theme.colors.green[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.green[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.green[400]};
            }
          `;
    default:
      return !isInverted
        ? css`
            background-color: ${({ theme }) => theme.colors.grey[300]};
            color: ${({ theme }) => theme.colors.grey[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.grey[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.grey[400]};
            }
          `
        : css`
            border: 1px solid ${({ theme }) => theme.colors.grey[300]};
          `;
  }
}

export const WeldActionButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
})<WeldStyledProps>`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  min-width: ${buttonWidth};
  ${getActionStyles};
`;

export const WeldActionUnclamiedButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
})<WeldStyledProps>`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  margin-right: ${({ theme }) => theme.spacings[200]};
  min-width: ${buttonWidth};
  ${getActionStyles};
`;

// TODO: look at abstracting this to account for other statuses if needed
export const SecondaryActionButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
})<ButtonComponentProps>`
  background-color: ${({ theme }) => theme.colors.orange[300]};
  border-color: ${({ theme }) => theme.colors.orange[300]};
  color: ${({ theme }) => theme.colors.orange[900]};
  margin-right: ${({ theme }) => theme.spacings[200]};
  min-width: ${buttonWidth};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  &:hover {
    background-color: ${({ theme }) => theme.colors.orange[200]};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.orange[400]};
  }
`;

export const HeadingStyled = styled(Heading)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
    background: ${theme.colors.grey[200]};
    padding-bottom: ${theme.spacings[500]};
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
    padding-top: ${theme.spacings[600]};
    border: solid 1px ${theme.colors.grey[300]};
    color: ${theme.colors.grey[1000]};
  `}
`;
